module.exports = __webpack_public_path__ + "img/ics_o_download.85524961.svg";